module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_styled_03-e0f29cf5d6ffb67498c5027bc4e3a42a.png";